import classNames from 'clsx';
import React, { ReactElement } from 'react';
import { HEADER_ID } from 'reactApp/constants/magicIdentificators';

import styles from './Header.css';

export enum EHeaderColor {
    BLUE = 'blue',
    WHITE = 'white',
}

interface IProps {
    children: React.ReactNode;
    color?: EHeaderColor;
    isPhone?: boolean;
}

export const HeaderWrapper: React.FC<IProps> = ({ color = EHeaderColor.WHITE, children, isPhone }): ReactElement => (
    <div
        className={classNames({
            [styles.root]: true,
            [styles[`root_color_${color}`]]: color,
            [styles.root_phone]: isPhone,
            [styles.root_desktop]: !isPhone,
        })}
        id={HEADER_ID}
    >
        {children}
    </div>
);
